import { normalizeInputDigits } from './inputDigits';

// Validate the entire amount. Never turn a malformed amount into a different one.
export function parseDecimalInput(input: string, language: string): number | null {
  const normalized = normalizeInputDigits(input.trim(), language).replace(',', '.');
  if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(normalized)) return null;
  const amount = Number(normalized);
  return Number.isFinite(amount) ? amount : null;
}
